module.exports = __webpack_public_path__ + "static/about_map_new-0b23873eb98c65f0f82e624d9dd93614.png";